import React, { useState, useEffect, Fragment } from "react";
import {Button, Accordion, Modal, Form} from "react-bootstrap";
import { useForm } from "react-hook-form";
import SolutionService from "../services/solution.service";


const Problem = ({ problem }) => {

   var url = '/solution/problem/'+problem.problemid;

   const [solution, setSolution] = useState([]);
   const [errorSubmit, setErrorSubmit] = useState("");
   const [loading, setLoading] = useState([]);
   const [show, setShow] = useState(false);
   const handleClose = () => setShow(false);
   const handleShow = () => setShow(true);

   const {
      register: registerSolution,
      formState: { errors: errorsSolution },
      handleSubmit: handleSubmitSolution,
    } = useForm({
      mode: "onTouched",
      reValidateMode: "onSubmit",
      defaultValues: {
        description: "",
      },
    });

   useEffect(() => { 
      const loadSolution = async (problemid) => { 
        try{
          setLoading(true); 
          const response = await SolutionService.getSolutionByProblem(problemid);
          setSolution(response.data); 
          setLoading(false); 
        }
        catch(error){
          setLoading(false);
        }
        
      }
      loadSolution(problem.problemid);
    }, []);  


   const onSubmitSolution = async (data) => {
      const { description } = data;

      try {
        setErrorSubmit("");
        setLoading(true); 
        const solid = await SolutionService.addSolutionByProblem(problem.problemid, description);
        setErrorSubmit("Solution Submitted!");

        setLoading(false);    
     } catch (errorSubmit) {
        setLoading(false);
        setErrorSubmit(errorSubmit.response?.data.message);
     }

  };

   return(
      <Fragment>
          <Accordion.Item eventKey={problem.problemid}>
            <Accordion.Header>{problem.title}</Accordion.Header>
            <Accordion.Body className="p-3"> 
               <div dangerouslySetInnerHTML={{__html:problem.description}} />
               <Button className="m-3" variant="primary" onClick={handleShow}>Submit Solution</Button>

               <Modal show={show} onHide={handleClose}>
               <Modal.Header closeButton>
                    <Modal.Title>{problem.title}</Modal.Title>
                </Modal.Header>
                  <Modal.Body>
                     <Form onSubmit={handleSubmitSolution(onSubmitSolution)}>
                        <Form.Group className="mb-3" controlId="formDescription">
                           <Form.Control as="textarea" rows="3" placeholder="Solution" 
                                 {...registerSolution("description", {
                                 required: "Solution can't be empty",
                                 
                                 })}
                           />  
                           {errorsSolution.description && (
                              <Form.Text className="text-danger">
                              {errorsSolution.description.message}
                              </Form.Text>
                           )}                     
                        </Form.Group>
                        <Button variant="primary" type="submit">
                                    Submit Solution 
                        </Button>  
                        {errorSubmit && (
                                    <Form.Text className="text-danger">
                                    {errorSubmit}
                                    </Form.Text>
                                 )}  
                     </Form>
                  </Modal.Body>
               </Modal>
            
            </Accordion.Body>
         </Accordion.Item>
      </Fragment>
   );


};

export default Problem;